(() => {
  const wishlistKey = 'hs_wishlist_v1';
  const recentKey = 'hs_recent_products_v1';
  const recentSearchKey = 'hs_recent_searches_v1';
  const read = (key) => {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; }
  };
  const write = (key, value) => localStorage.setItem(key, JSON.stringify(value));
  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const optionalBoolean = (value) => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return undefined;
  };
  const itemFrom = (element) => ({
    handle: element.dataset.productHandle,
    title: element.dataset.productTitle,
    url: element.dataset.productUrl,
    image: element.dataset.productImage,
    price: element.dataset.productPrice,
    vendor: element.dataset.productVendor,
    condition: element.dataset.productCondition,
    size: element.dataset.productSize,
    fit: element.dataset.productFit,
    available: optionalBoolean(element.dataset.productAvailable),
    published: optionalBoolean(element.dataset.productPublished),
  });
  const announce = (message) => {
    let region = document.querySelector('[data-hs-toast]');
    if (!region) {
      region = document.createElement('div');
      region.dataset.hsToast = '';
      region.className = 'hs-toast';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.append(region);
    }
    region.textContent = message;
    region.classList.add('is-visible');
    setTimeout(() => region.classList.remove('is-visible'), 2600);
  };
  const sync = () => {
    const items = read(wishlistKey);
    document.querySelectorAll('[data-hs-wishlist-count]').forEach((count) => {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-hs-wishlist-toggle]').forEach((button) => {
      const saved = items.some((item) => item.handle === button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(saved));
      button.classList.toggle('is-saved', saved);
      if (button.matches('.button')) button.textContent = saved ? 'Saved to wishlist' : 'Save to wishlist';
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hs-wishlist-toggle]');
    if (!button) return;
    const item = itemFrom(button);
    if (!item.handle) return;
    const items = read(wishlistKey);
    const index = items.findIndex((saved) => saved.handle === item.handle);
    if (index >= 0) {
      items.splice(index, 1);
      announce('Removed from wishlist');
    } else {
      items.unshift(item);
      announce('Saved to wishlist');
    }
    write(wishlistKey, items.slice(0, 100));
    sync();
    document.dispatchEvent(new CustomEvent('hs:commerce', { detail: { hs_event_name: index >= 0 ? 'wishlist_remove' : 'wishlist_add' } }));
  });
  const current = document.querySelector('[data-hs-current-product]');
  if (current) {
    try {
      const product = JSON.parse(current.textContent);
      const recent = read(recentKey).filter((item) => item.handle !== product.handle);
      recent.unshift(product);
      write(recentKey, recent.slice(0, 12));
    } catch {}
  }
  const renderCards = (container, items, emptyText) => {
    if (!container) return;
    if (!items.length) {
      container.innerHTML = `<p class="hs-customer-empty">${escapeHtml(emptyText)}</p>`;
      return;
    }
    const root = window.Shopify?.routes?.root || '/';
    container.innerHTML = items.map((item) => {
      const details = [
        item.size ? `Tagged ${escapeHtml(item.size)}` : '',
        item.fit ? `Fits ${escapeHtml(item.fit)}` : '',
      ].filter(Boolean);
      const detailMarkup = details.length
        ? `<div class="hs-customer-card__meta">${details.map((detail) => `<span>${detail}</span>`).join('')}</div>`
        : '';
      const conditionMarkup = item.condition
        ? `<span class="hs-customer-card__condition hs-condition-badge">${escapeHtml(item.condition)}</span>`
        : '';
      const productUrl = `${root}products/${encodeURIComponent(item.handle)}`;

      return `<article class="hs-customer-card"><a href="${escapeHtml(productUrl)}"><div class="hs-customer-card__media">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy" width="600" height="750">` : ''}${conditionMarkup}</div><p class="hs-customer-card__brand">${escapeHtml(item.vendor)}</p><h3>${escapeHtml(item.title)}</h3>${detailMarkup}<strong>${escapeHtml(item.price)}</strong></a></article>`;
    }).join('');
  };
  document.querySelectorAll('[data-hs-wishlist-grid]').forEach((container) => renderCards(container, read(wishlistKey), 'Your wishlist is empty. Save products to compare them here.'));
  document.querySelectorAll('[data-hs-recent-grid]').forEach((container) => {
    const currentHandle = container.dataset.currentHandle;
    const limit = Number(container.dataset.limit || 4);
    const section = container.closest('[data-hs-recent-section]');
    const isDesignMode = section && section.dataset.hsDesignMode === 'true';
    const eligible = read(recentKey).filter((item) => (
      item.handle !== currentHandle
      && item.available === true
      && item.published === true
    ));
    if (!eligible.length) {
      if (isDesignMode) {
        renderCards(container, [], 'Recently viewed products appear here after a customer browses the catalogue.');
      } else {
        container.replaceChildren();
        if (section) section.hidden = true;
      }
      return;
    }
    renderCards(container, eligible.slice(0, limit), '');
    if (section) section.hidden = false;
  });
  document.querySelectorAll('form[action*="/search"]').forEach((form) => {
    form.addEventListener('submit', () => {
      const query = String(new FormData(form).get('q') || '').trim().slice(0, 80);
      if (!query) return;
      const searches = read(recentSearchKey).filter((item) => item.toLowerCase() !== query.toLowerCase());
      searches.unshift(query);
      write(recentSearchKey, searches.slice(0, 5));
    });
  });
  document.querySelectorAll('[data-hs-recent-searches]').forEach((container) => {
    const searches = read(recentSearchKey);
    if (!searches.length) return;
    container.hidden = false;
    container.querySelector('div').innerHTML = searches.map((query) => `<a href="/search?q=${encodeURIComponent(query)}">${escapeHtml(query)}</a>`).join('');
  });
  sync();
})();
